<template>
    <div class="main" style="padding-bottom:50px">
        <div @click="redirectPreviousUrl"
            style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
            <p>
                <a-icon type="double-left" />
            </p>
            <p>Go Back </p>

        </div>
        <div style="margin-top:30px;background:#fff">

            <div style="padding:60px">
                <a-row>
                    <a-col :span="12">
                        <a-row>
                            <a-col :span="8">
                                <!-- <div style="background-color:#ccc;;width: 70px; height: 37px;margin-top:5px;"></div> -->
                            </a-col>
                            <a-col :span="12">
                                <div>
                                    <!-- <span style="font-size:20px; font-weight:bolder">{{supplierDetails.name}}</span>
                                    <span style="font-size:13px;display:block">{{supplierDetails.address}}</span>
                                     -->
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="12">
                        <div style="float:right">
                            <span style="font-size:20px; font-weight:bolder">PURCHASE ORDER</span>
                            <span style="font-size:13px;display:block">DATE: {{ currentDate }}</span>
                            <span style="font-size:16px;display:block">{{ getPurchaseOrderIder }}</span>
                        </div>
                    </a-col>
                </a-row>
                <a-row style="margin-top:30px">
                    <a-col :span="12">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <a-row>
                                <a-col :span="8">
                                    Supplier:
                                </a-col>
                                <a-col :span="14">
                                    <span style="font-weight:bolder">
                                        <a-form-model>
                                            <a-input v-model="supplierName" placeholder="Supplier name?" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="supplierAddress" placeholder="Address" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="supplierCity" placeholder="Region" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="supplierCountry" placeholder="Country" />
                                        </a-form-model>
                                    </span>
                                </a-col>
                            </a-row>
                        </div>

                    </a-col>
                    <a-col :span="12">
                        <div style="border: 2px solid #ccc;padding: 20px;border-left: hidden;">
                            <a-row>
                                <a-col :span="8">
                                    Ship To:
                                </a-col>
                                <a-col :span="14">
                                    <span style="font-weight:bolder">
                                        <a-form-model>
                                            <a-select show-search placeholder="Choose your suplier"
                                                option-filter-prop="children" v-model="destionation"
                                                :filter-option="filterOption" @change="onWareHouseChange">
                                                <a-select-option v-for="warehouse in availableWareHouseCenters"
                                                    :key="warehouse.id" v-bind:value="warehouse.id">
                                                    {{ warehouse.name }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="sellerAddress" placeholder="Address" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="shipCity" placeholder="Region" />
                                        </a-form-model>
                                    </span>
                                    <span style="font-size:10px;display:block">
                                        <a-form-model>
                                            <a-input v-model="shipCountry" placeholder="Country" />
                                        </a-form-model>
                                    </span>
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                </a-row>
                <a-row style="margin-top:30px;display: flex; justify-content: space-between">
                    <a-col :span="12">
                        <div style="font-weight:bolder">Shipping Method</div>
                        <div style="">
                            <a-select default-value="Land" v-model="shippingMethod" style="width: 120px">
                                <a-select-option value="0">
                                    Land
                                </a-select-option>
                                <a-select-option value="2">
                                    Air
                                </a-select-option>
                                <a-select-option value="1">
                                    Sea
                                </a-select-option>
                            </a-select>
                        </div>
                    </a-col>

                    <a-col :span="12" style="text-align: end;">
                        <div style="font-weight:bolder">Delivery Date</div>
                        <div style="">
                            <a-form-model>
                                <a-date-picker v-model="deliveryDate" @change="onDeliveryDateChange" />
                            </a-form-model>
                        </div>
                    </a-col>
                </a-row>
                <div style="margin-top:20px;">
                    <div style="display: flex; justify-content: flex-end;padding: 14px;">
                        <a-button @click="handleAdd"
                            style="height:33px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                            icon="plus">
                            Add Product
                        </a-button>
                    </div>

                    <a-table bordered :columns="columns" :data-source="tableData" :pagination="false"
                        :loading="tableLoading" :scroll="{ x: 20, y: 400 }" class="modalTable">
                        <template slot="quantity" slot-scope="text, record">
                            <quantity-editable-cell :text="text"
                                @change="onQauntityCellChange(record.key, 'quantity', $event)" />
                        </template>
                        <template slot="unitPrice" slot-scope="text, record">
                            <unit-price-editable-cell :text="text"
                                @change="onUnitPriceCellChange(record.key, 'unitPrice', $event)" />
                        </template>
                        <!-- <template slot="name" slot-scope="text, record">
                            <product-name-editable-cell :text="text" :tableData="tableData" @change="onProductNameCellChange(record.key, 'name', $event)" />
                        </template> -->
                        <template slot="category" slot-scope="text, record">
                            <category-editable-cell :text="text"
                                @change="onCategoryNameCellChange(record.key, 'category', $event)" />
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a-popconfirm v-if="tableData.length" title="Delete this product?"
                                @confirm="() => onDelete(record.key)">
                                <a-icon style="cursor:pointer;display:flex;justify-content:center;"
                                    type="minus-circle-o" />
                            </a-popconfirm>
                        </template>
                    </a-table>
                </div>

                <a-row type="flex" justify="end" style="margin-top:10px;">
                    <a-col :span="12">
                        <a-form-model-item label="Terms" ref="" prop="">
                            <a-textarea class="descInputText" v-model="shippinTerm" :maxLength="300" placeholder="Terms"
                                :auto-size="{ minRows: 3, maxRows: 5 }" />
                            <small style="color:red">Maximun characters is 300</small>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-row style="display:flex;justify-content: flex-end;">
                            <a-col style="font-weight:bolder;font-size: 19px;" :span="8">Sub Total: </a-col>
                            <a-col :span="12" style="font-size: 19px;font-weight:bolder;">Ksh {{
            displayTotalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</a-col>
                        </a-row>
                        <a-row style="display:flex;justify-content: flex-end;">
                            <a-col style="font-weight:bolder;font-size: 19px;" :span="8">Discount: </a-col>
                            <a-col style="display:flex; height:20px;font-size: 19px;" :span="12">
                                <a-form-model>
                                    <a-input-number v-model="discount" />
                                </a-form-model>
                            </a-col>
                        </a-row>
                        <a-row style="display:flex;justify-content: flex-end;padding-top:30px">
                            <a-col style="font-weight:bolder;font-size: 25px;" :span="10">Grand Total: </a-col>
                            <a-col style="font-weight:bolder;font-size: 25px;" :span="12">Ksh {{
            displayGrandTotal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</a-col>
                        </a-row>
                    </a-col>
                </a-row>

                <div style="display:flex;justify-content: center;padding-top: 40px;">
                    <a-button :disabled="tableData.length === 0" :loading="loading" @click="generatPurchaseOrder"
                        :class="[tableData.length > 0 ? 'activeBtn' : 'disbablesBtn']"> Submit & Save </a-button>
                </div>
            </div>

        </div>
        <a-modal class="modalStyle" :visible="addProductVisible" :footer="null" @cancel="handleAddProductCancel">
            <div style="display:flex;justify-content: center;">
                <img class="img_size" src="../../../assets/img/inventory_1.png" />
            </div>
            <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Add New Product</p>
            <div>
                <a-form-model ref="addProductForm" :model="newProductForm" :rules="rules">
                    <a-row type="flex" justify="center" align="middle">
                        <a-col :span="16">
                            <a-form-model-item label="Select Product" ref="productId" prop="productId">
                                <a-select show-search placeholder="Choose your product" option-filter-prop="children"
                                    v-model="newProductForm.productId" :filter-option="filterOption"
                                    @change="onProductChange">
                                    <a-select-option v-for="product in availableProducts" :key="product.id"
                                        v-bind:value="product.id">
                                        {{ product.brandName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                    </a-row>

                    <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                        <a-spin class="spinner" :spinning="loading" />
                    </div>
                    <div v-show="showAlertMsg" style="display:flex;justify-content: center;padding-bottom: 10px;">
                        <a-alert message="Product already exist, kindly choose a different product." type="error" />
                    </div>

                    <a-form-model-item
                        style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                        <a-button :loading="modalLoading" @click="addProduct"
                            style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                            Add Product
                        </a-button>
                    </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';


const columns = [
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name",
        // scopedSlots: { customRender: 'name' },
        width: 250,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 250,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity",
        scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Unit Price',
        dataIndex: 'unitPrice',
        key: "unitPrice",
        scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    {
        title: 'Line Total',
        dataIndex: 'lineTotal',
        key: "lineTotal"
        // width: 200,
    },
    {
        title: 'Action',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
    },
]

import QuantityEditableCell from '../../preorder/common/QuantityEditableCell';
import UnitPriceEditableCell from '../../preorder/common/UnitPriceEditableCell';
// import ProductNameEditableCell from './common/ProductNameEditableCell';
import CategoryEditableCell from '../../preorder/common/CategoryEditableCell';
import { IsJsonString } from '@/utils/index'
import { NotificationMixins } from "@/mixins/NotificationMixins";

export default {
    name: "PurchaseOrderEdit",
    components: {
        QuantityEditableCell,
        UnitPriceEditableCell,
        // ProductNameEditableCell,
        CategoryEditableCell
    },
    mixins: [NotificationMixins],
    data() {
        return {
            columns,
            addProductVisible: false,
            modalLoading: false,
            tableData: [],
            loading: false,
            tableLoading: false,
            discount: 0,
            deliveryDate: null,
            supplierId: "",
            supplierName: "",
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            destionationName: "",
            sellerAddress: "",
            shipCity: "",
            shipCountry: "",
            shippingMethod: "0",
            shippinTerm: "",
            originalData: [],
            statusLabel: "",
            action: "",
            showAlertMsg: false,
            newProductForm: {
                productId: "",

            },
            newPreOrderProduct: {},
            availableProducts: [],
            availableWareHouseCenters: [],
            params: {
                page: 1,
                perPage: 10,
                searchBy: {},
                sortBy: {}
            },
            supplierDetails: {},
            purchaseOrderId: "",
            rules: {
                maxQuantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[0-9]*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                productId: [
                    { required: true, message: 'Please select product', trigger: 'change' },
                ],

                quantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],

                price: [
                    { required: true, message: 'Please enter price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters(['getPreViewInfo']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.quantity) {
                    return parseFloat(item.unitPrice) * item.quantity
                } else {
                    return 0.00
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt)

        },
        getPurchaseOrderIder() {
            return this.purchaseOrderId ? `Order #PO-${this.purchaseOrderId}` : ""
        },
        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount)
        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'getSupplierProducts', 'getAllWarehousesData', 'generatePurchaseOrder', 'updateGeneratedPurchaseOrder']),
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        onDeliveryDateChange(date) {
            // console.log("date | ", moment(data).format())
            this.deliveryDate = moment(date)
            // console.log("deliveryDate", this.deliveryDate);
        },
        onProductChange(value) {
            // console.log("value  | ",value)
            let filterProduct = this.availableProducts.filter(product => product.id === value)
            // console.log("filterProduct  | ",filterProduct)
            this.newPreOrderProduct = filterProduct[0]
        },
        onWareHouseChange(value) {
            if (value) {
                let filterWarehouseCenter = this.availableWareHouseCenters.find(warehouse => warehouse.id === value)
                this.sellerAddress = filterWarehouseCenter.address
                this.destionation = filterWarehouseCenter.id
                this.destionationName = filterWarehouseCenter.name
            }
        },
        handleAddProductCancel() {
            this.addProductVisible = false;
        },
        handleAdd() {
            this.addProductVisible = true;
        },
        redirectPreviousUrl() {
            this.$router.back()
        },


        async generatPurchaseOrder() {
            if (this.deliveryDate === null || this.deliveryDate === "") {
                this.showErrorAlert("Kindly select delivery date")
            } else if (this.destionation === null || this.destionation === "") {
                this.showErrorAlert("Kindly select warehouse")
            } else {
                this.loading = true

                const productLines = this.tableData.map(product => ({
                    productId: product.productId,
                    quantity: parseInt(product.quantity),
                    price: parseFloat(product.unitPrice)
                }))

                const supplierAddress = {
                    supplierAddress: this.supplierAddress,
                    supplierCity: this.supplierCity,
                    supplierCountry: this.supplierCountry,
                }

                const sellerAddress = {
                    sellerAddress: this.sellerAddress,
                    shipCity: this.shipCity,
                    shipCountry: this.shipCountry,
                    destionation: this.destionation,
                    destionationName: this.destionationName
                }

                const request = {
                    supplierId: parseInt(this.supplierId),
                    supplierAddress: JSON.stringify(supplierAddress),
                    sellerAddress: JSON.stringify(sellerAddress),
                    shippingMethod: parseInt(this.shippingMethod),
                    terms: this.shippinTerm,
                    discount: this.discount ? this.discount : 0,
                    deliveryDate: this.deliveryDate ? moment(this.deliveryDate).format() : '',
                    productLines: productLines
                }

                if (this.action === "add") {
                    const response = await this.$store.dispatch("purchaseOrder/generatePurchaseOrder", request)
                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("Purchase Order Generated Successfully")
                        this.$router.push('/purchase-order-history').catch(() => { });
                    } else {
                        this.showErrorAlert("Something went wrong, try again later")
                        console.log("Error | ", request)
                    }
                } else {

                    const data = {
                        id: this.puchaseOrderid,
                        data: request
                    }
                    const response = await this.$store.dispatch("purchaseOrder/updateGeneratedPurchaseOrder", data)
                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("Purchase Order Updated Successfully")
                        this.$router.push('/purchase-order-history').catch(() => { });
                    } else {
                        this.showErrorAlert("Something went wrong, try again later")
                        console.log("Error | ", request)
                    }
                }
            }

        },
        onProductNameCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            // console.log("target | ", target)
            if (target) {
                target[dataIndex] = value.name;
                target['key'] = value.name;
                target['id'] = parseInt(value.id);
                this.tableData = tableData;
            }
            // console.log("dataSource | ", this.tableData)
        },
        onCategoryNameCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            // console.log("target | ", target)
            if (target) {
                target[dataIndex] = value.name;
                target['key'] = value.name;
                target['id'] = parseInt(value.id);
                this.tableData = tableData;
            }
            // console.log("dataSource | ", this.tableData)
        },
        onUnitPriceCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            if (target) {
                target[dataIndex] = value;
                target["lineTotal"] = (parseFloat(value) * parseInt(target.quantity)).toFixed(2);
                this.tableData = tableData;
            }
        },
        onQauntityCellChange(key, dataIndex, value) {
            // console.log("key | ", key)
            // console.log("dataIndex | ", dataIndex)
            // console.log("value | ", value)
            const tableData = [...this.tableData];
            const target = tableData.find(item => item.key === key);
            // console.log("target | ", target)
            if (target) {
                target[dataIndex] = value;
                target["lineTotal"] = (parseFloat(target.unitPrice) * parseInt(value)).toFixed(2);
                this.tableData = tableData;
            }
        },
        onDelete(key) {
            // console.log("key | ", key)
            const tableData = [...this.tableData];
            this.tableData = tableData.filter(item => item.key !== key);
        },

        addProduct() {
            this.$refs.addProductForm.validate(valid => {
                if (valid) {
                    // let request_data = {
                    //     id:this.getOrder.id,
                    //     data: {
                    //         productId : this.newProductForm.productId,
                    //         maxQuantity: this.newProductForm.maxQuantity,
                    //     }
                    // }
                    // console.log("exit product | ", this.checkExistingProduct(this.newProductForm.productId))
                    // console.log("request_data | ", request_data)
                    // console.log("id | ", this.getOrder.id)
                    // console.log("request_data | ", request_data)
                    if (this.checkExistingProduct(this.newProductForm.productId)) {
                        this.showAlertMsg = true;
                    } else {
                        this.showAlertMsg = false;
                        this.modalLoading = true;

                        // console.log("newPreOrderProduct | ", this.newPreOrderProduct)

                        let productObj = {
                            key: this.randomString(10),
                            productId: this.newPreOrderProduct.id,
                            name: this.newPreOrderProduct.brandName,
                            category: this.newPreOrderProduct.categoryName,
                            quantity: "0",
                            unitPrice: this.newPreOrderProduct.purchasePrice.toString(),
                            lineTotal: parseInt(0) * parseFloat(this.newPreOrderProduct.purchasePrice)
                        }
                        this.tableData.push(productObj)
                        this.modalLoading = false;
                        this.addProductVisible = false

                    }
                } else {
                    return false;
                }
            })
        },
        checkExistingProduct(productId) {
            return this.tableData.some(product => product.id === productId)
        },

        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },

        async loadSupplierProducts() {
            let params = {
                page: -1,
                perPage: -1,
                searchBy: {
                    supplierId: this.supplierId
                },
                sortBy: {}
            }

            const response = await this.$store.dispatch("purchaseOrder/getSupplierProducts", params)
            if (response.status === 200) {
                this.availableProducts = response.data.data;
            } else {
                console.log('Error | ', response)
            }

        }

    },
    created() {
        if (this.getAllWarehousesData) {
            this.getAllWarehousesData().then(response => {
                //    
                if (response.status === 200) {
                    this.availableWareHouseCenters = response.data.data;
                } else {
                    console.log('Error | ', response)
                }
            }, error => {
                console.log('Error | ', error)
            })
        }
        // console.log("getPreViewInfo | ", this.getPreViewInfo)
        if (this.getPreViewInfo) {
            // console.log("getPreViewInfo | ", this.getPreViewInfo)
            let result = JSON.parse(this.getPreViewInfo)
            // console.log("result  | ", result)

            if (IsJsonString(result.supplierAddress)) {
                const json = JSON.parse(result.supplierAddress)
                this.supplierAddress = json.supplierAddress ? json.supplierAddress : ""
                this.supplierCity = json.supplierCity ? json.supplierCity : ""
                this.supplierCountry = json.supplierCountry ? json.supplierCountry : ""
            } else {
                this.supplierAddress = result.supplierAddress ? result.supplierAddress : ""
                this.supplierCity = ""
                this.supplierCountry = ""
            }

            if (IsJsonString(result.sellerAddress)) {
                const json = JSON.parse(result.sellerAddress)
                this.sellerAddress = json.sellerAddress ? json.sellerAddress : "",
                    this.shipCity = json.shipCity ? json.shipCity : "",
                    this.shipCountry = json.shipCountry ? json.shipCountry : ""
                this.destionation = json.destionation ? json.destionation : ""
                this.destionationName = json.destionationName ? json.destionationName : ""
            } else {
                this.sellerAddress = ""
                this.shipCity = "",
                    this.shipCountry = ""
                this.destionation = ""
                this.destionationName = ""
            }
            this.purchaseOrderId = result.purchaseOrderId
            this.discount = result.discount,
                this.deliveryDate = result.deliveryDate ? moment(result.deliveryDate) : null,
                this.supplierId = result.supplierId,
                this.supplierName = result.supplierName,
                this.statusLabel = result.statusLabel
            this.shippingMethod = result.shippingMethod ? result.shippingMethod : "0",
                this.shippinTerm = result.shippinTerm,
                this.tableData = result.tableData
            this.action = result.action
            this.puchaseOrderid = result.purchaseOrderId
            // this.deliveriestableData = result.deleiveries
        }
        if (this.loadSupplierProducts) {
            this.loadSupplierProducts()
        }
        // if(this.getSupplierDetails){
        //     this.getSupplierDetails(this.getPreViewInfo.supplierId)
        // }
    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

.disbablesBtn {
    color: rgba(0, 0, 0, .25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    height: 38px;
    border-raduis: 5px;
}

.activeBtn {
    height: 38px;
    margin-right: 10px;
    border-raduis: 5px;
    background: #418a49;
    color: #fff;
}
</style>